export var getColumnsStyles = function getColumnsStyles(_ref) {
  var columnsConfig = _ref.columnsConfig,
    layoutType = _ref.layoutType;
  switch (layoutType) {
    case 'mobile':
      if (columnsConfig.mobile) {
        return {
          gridTemplateColumns: "repeat(".concat(columnsConfig.mobile.amount, ", minmax(").concat(columnsConfig.mobile.minWidth, "px, 1fr))")
        };
      }
      break;
    case 'tablet':
      if (columnsConfig.tablet) {
        return {
          gridTemplateColumns: "repeat(".concat(columnsConfig.tablet.amount, ", minmax(").concat(columnsConfig.tablet.minWidth, "px, 1fr))")
        };
      }
      break;
    case 'desktopSmall':
      if (columnsConfig.desktopSmall) {
        return {
          gridTemplateColumns: "repeat(".concat(columnsConfig.desktopSmall.amount, ", minmax(").concat(columnsConfig.desktopSmall.minWidth, "px, 1fr))")
        };
      }
      if (columnsConfig.desktop) {
        return {
          gridTemplateColumns: "repeat(".concat(columnsConfig.desktop.amount, ", minmax(").concat(columnsConfig.desktop.minWidth, "px, 1fr))")
        };
      }
      break;
    case 'desktop':
      if (columnsConfig.desktop) {
        return {
          gridTemplateColumns: "repeat(".concat(columnsConfig.desktop.amount, ", minmax(").concat(columnsConfig.desktop.minWidth, "px, 1fr))")
        };
      }
      break;
    default:
      return undefined;
  }
};